import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { Box, Chip } from '@mui/material';
import { HTMLAttributes } from 'react';
import {
  ClientConfigGroupLike,
  getClientConfigGroupColor,
  isClientConfigGroupGlobal,
} from '../../lib/clientConfigHelpers';

const getReadableTextColor = (backgroundColor: string) => {

  const hex = backgroundColor.replace('#', '');
  if (hex.length !== 6) {

    return '#ffffff';

  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 145 ? '#1e1e1e' : '#ffffff';

};

type ClientConfigGroupChipGroup = Pick<ClientConfigGroupLike, '_id' | 'name' | 'customer'> & {
  id?: string;
};

type ClientConfigGroupChipProps = {
  group: ClientConfigGroupChipGroup;
  getTagProps?: (args: { index: number }) => Record<string, unknown>;
  index?: number;
  size?: 'small' | 'medium';
  struckThrough?: boolean;
};

export const ClientConfigGroupChip = ({
  group,
  getTagProps,
  index,
  size = 'small',
  struckThrough = false,
}: ClientConfigGroupChipProps) => {

  const groupId = group._id || group.id;
  if (!groupId) {

    return null;

  }
  const label = group.name || groupId;
  const color = getClientConfigGroupColor(String(groupId));
  const textColor = getReadableTextColor(color);
  const tagProps = getTagProps && index !== undefined ? getTagProps({ index }) : {};
  return (
    <Chip
      {...tagProps}
      size={size}
      label={label}
      icon={isClientConfigGroupGlobal(group) ? <PublicIcon fontSize="small"/> : <PublicOffIcon fontSize="small"/>}
      sx={{
        backgroundColor: color,
        color: textColor,
        fontWeight: 600,
        marginRight: '6px',
        marginTop: '2px',
        marginBottom: '2px',
        textDecoration: struckThrough ? 'line-through' : 'none',
        opacity: struckThrough ? 0.65 : 1,
        '& .MuiChip-label': {
          textDecoration: struckThrough ? 'line-through' : 'none',
        },
        '& .MuiChip-icon': {
          color: textColor,
        },
      }}
    />
  );

};

export const ClientConfigGroupAutocompleteOption = ({
  optionProps,
  group,
}: {
  optionProps: HTMLAttributes<HTMLLIElement> & { key?: string };
  group: ClientConfigGroupChipGroup;
}) => {

  const { key, ...liProps } = optionProps;
  return (
    <Box component="li" key={key} {...liProps}>
      <ClientConfigGroupChip group={group} />
    </Box>
  );

};
